import { GetProjetosChecklistByIdResponse } from "../../../data/daos/read/get_projetos_checklist_by_id";
import { IGetProjetosChecklistByIdUseCase } from "../../../presentation/useCases/read/get_projetos_checklist_by_id_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * GetProjetosChecklistByIdUseCase
 */

export class GetProjetosChecklistByIdUseCase implements IGetProjetosChecklistByIdUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async getProjetosChecklistById(id: number): Promise<GetProjetosChecklistByIdResponse> {
    return await this.repository.getByIdProjetosChecklist(id);
  }
}
